import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\"><path d=\"m936.833 853.8-164.3-164.3c52.5-65.9 83.9-149.3 83.9-240.1 0-212.9-172.6-385.6-385.6-385.6s-385.6 172.7-385.6 385.6 172.6 385.6 385.6 385.6c90.9 0 174.5-31.5 240.4-84.1l164.3 164.3c16.7 16.7 44 16.7 60.7 0l.6-.6c16.7-16.8 16.7-44.1 0-60.8zm-764.8-404.4c0-165 133.8-298.8 298.8-298.8s298.8 133.8 298.8 298.8-133.8 298.9-298.8 298.9-298.8-133.8-298.8-298.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol